import { takeLatest, takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services"
import config from '../config/config.json';

function* updateMarketRates(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };


        const response = yield call(
            apiCall,
            'POST',
            config.credentials.url + '/update_market_rates/',
            requestOptions
        );

        yield put({ type: "RESPONSE_UPDATE_MARKET_RATES", value: response })
    } catch (error) {
        yield put({ type: "RESPONSE_UPDATE_MARKET_RATES", value: error })
    }
}

function* deleteMarketRates(actions) {

    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers
        };

        const response = yield call(apiCall, 'DELETE', config.credentials.url + '/update_market_rates/' + actions.query, requestOptions)

        yield put({ type: "RESPONSE_UPDATE_MARKET_RATES", value: response })
    } catch (error) {

        yield put({ type: "RESPONSE_UPDATE_MARKET_RATES", value: error })
    }
}

function* deleteRateRelations(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers
        };
        const response = yield call(apiCall, 'DELETE', config.credentials.url + '/rate_relations/' + actions.query, requestOptions)

        yield put({ type: "RESPONSE_DELETE_RATES_RELATIONS", value: response })
    } catch (error) {
        yield put({ type: "RESPONSE_DELETE_RATES_RELATIONS", value: error })
    }
}

function* createRateRelations(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data.rate)
        };

        const response = yield call(apiCall, 'POST', config.credentials.url + '/rate_relations/', requestOptions);
        yield put({ type: "RESPONSE_CREATE_RATES_RELATIONS", value: response })
    } catch (error) {
        yield put({ type: "RESPONSE_CREATE_RATES_RELATIONS", value: error })
    }
}

function* updateBatchRates(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'POST', config.credentials.url + '/update_pvp_rates/', requestOptions);

        yield put({ type: "GET_RESPONSE_BACH_UPDATE_RATES", value: response })
    } catch (error) {
        yield put({ type: "GET_RESPONSE_BACH_UPDATE_RATES", value: error })
    }
}

function* getBatchAllRates(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = `${config.credentials.url}/update_pvp_rates/`

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "GET_RESPONSE_All_UPDATE_RATES", value: response })
    } catch (error) {
        yield put({ type: "GET_RESPONSE_All_UPDATE_RATES", value: error })
    }
}

function* getFilteredRates(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = actions.query === null
            ? `${config.credentials.url}/update_pvp_rates/`
            : `${config.credentials.url}/update_pvp_rates/${actions.query}`

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "GET_RATES_FILTERED_LIST", value: response })
    } catch (error) {
        yield put({ type: "GET_RATES_FILTERED_LIST", value: error })
    }
}

function* getList(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = actions.query === null
            ? `${config.credentials.url}/rate/?offset=0&limit=${actions.limit}&office_type=${actions.officeType}`
            : `${config.credentials.url}/rate/${actions.query}`

        const response = yield call(apiCall, 'get', url, requestOptions)

        yield put({ type: "GET_RESPONSE_RATES_LIST", value: response })
    } catch (error) {
        yield put({ type: "GET_RESPONSE_RATES_LIST", value: error })
    }
}

function* rateById(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const response = yield call(apiCall, 'get', config.credentials.url + '/rate/' + actions.id + '/', requestOptions)

        yield put({ type: "GET_RATE_BY_ID", value: response })
    } catch (error) {
        yield put({ type: "GET_RATE_BY_ID", value: error })
    }
}

function* rateByIdSearchCopies(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const response = yield call(apiCall, 'get', config.credentials.url + '/rate/?rate_id=' + actions.id + '&search_copies=true', requestOptions)

        yield put({ type: "GET_RATE_BY_ID_SEARCH_COPY", value: response })
    } catch (error) {
        yield put({ type: "GET_RATE_BY_ID_SEARCH_COPY", value: error })
    }
}

function* editRate(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'put', config.credentials.url + '/rate/' + actions.id + '/', requestOptions)
        yield put({ type: "RATE_EDIT_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "RATE_EDIT_RESPONSE", value: error })
    }
}

function* getRateDetail(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const response = yield call(apiCall, 'get', config.credentials.url + '/rateDetail/' + actions.id + '/', requestOptions)

        yield put({ type: "GET_RATE_DETAIL_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "GET_RATE_DETAIL_RESPONSE", value: error })
    }
}

function* uploadRateJson(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const data = {
            "id": actions.rateDetailId,
            "rate": actions.rateId,
            "json_detail": actions.json,
            "office_comission": actions.office_comission
        }

        const requestOptions = {
            headers: headers,
            body: JSON.stringify(data)
        };

        const response = yield call(apiCall, 'put', config.credentials.url + '/rateDetail/' + actions.rateDetailId + '/', requestOptions)
        yield put({ type: "RATE_JSON_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "RATE_JSON_RESPONSE", value: error })
    }
}

function* uploadRateFile(actions) {
    try {
        const headers = {
            'Authorization': `Bearer ${actions.access}`,
        };
        const requestOptions = {
            headers: headers,
            body: actions.file
        };
        const response = yield call(apiCall, 'post', config.credentials.url + '/' + 'csv_upload' + '/', requestOptions)

        yield put({ type: "RATE_FILE_RESPONSE", value: response })
    } catch (error) {
        yield put({ type: "RATE_FILE_RESPONSE", value: error })
    }
}

function* duplicateRate(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };

        const requestOptions = {
            headers: headers
        };

        const url = actions.query === undefined || actions.query === null
            ? config.credentials.url + '/product_rate_detail/?id=&product=&rate_detail=&office=&rate_detail__rate__id=' + actions.id
            : config.credentials.url + '/product_rate_detail/' + actions.query

        const response = yield call(apiCall, 'get',
            url,
            requestOptions)

        yield put({ type: "GET_DUPLICATE_RATE_REPONSE", value: response })
    } catch (error) {
        yield put({ type: "GET_DUPLICATE_RATE_REPONSE", value: error })
    }
}

function* downloadRate(actions) {
    try {
        const headers = {
            'Content-Type': "application/json",
            'Authorization': `Bearer ${actions.access}`
        };
        const requestOptions = {
            headers: headers,
            body: JSON.stringify(actions.data)
        };

        const response = yield call(apiCall, 'post', config.credentials.url + '/' + 'download_rate_values' + '/', requestOptions)

        yield put({ type: "GET_DOWNLOAD_RATE_REPONSE", value: response })
    } catch (error) {
        yield put({ type: "GET_DOWNLOAD_RATE_REPONSE", value: error })
    }
}

function* checkExportRate(actions) {
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${actions.access}`,
        };
        const requestOptions = {
            headers: headers,
        };

        const response = yield call(
            apiCall,
            'GET',
            config.credentials.url + '/report/' + actions.hash + '/',
            requestOptions
        );

        yield put({ type: 'REPORT_EXPORT_RATE_RESPONSE', value: response });
    } catch (error) {
        yield put({ type: 'REPORT_EXPORT_RATE_RESPONSE', value: error });
    }
}

function* hashExportListRates(actions) {
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${actions.access}`,
        };
        const requestOptions = {
            headers: headers,
        };

        let url =
            actions.query === null
                ? config.credentials.url + '/rate_report/?offset=0&limit=1000000'
                : config.credentials.url +
                '/rate_report/' +
                actions.query +
                '&offset=0&limit=100000';
        const response = yield call(apiCall, 'get', url, requestOptions);
        //saveAs(response.message, "filter_Rates.xlsx")
        yield put({ type: 'HASH_EXPORT_RATES_RESPONSE', value: response });
    } catch (error) {
        yield put({ type: 'HASH_EXPORT_RATES_RESPONSE', value: error });
    }
}

function* checkExportListRates(actions) {
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${actions.access}`,
        };
        const requestOptions = {
            headers: headers,
        };

        const response = yield call(
            apiCall,
            'GET',
            config.credentials.url + '/report/' + actions.hash + '/',
            requestOptions
        );

        yield put({ type: 'REPORT_EXPORT_RATES_RESPONSE', value: response });
    } catch (error) {
        yield put({ type: 'REPORT_EXPORT_RATES_RESPONSE', value: error });
    }
}

function* updateExportListRates(actions) {
    try {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${actions.access}`,
        };
        const requestOptions = {
            headers: headers,
        };

        const response = yield call(
            apiCall,
            'PUT',
            config.credentials.url + '/report/' + actions.hash + '/',
            requestOptions
        );

        yield put({ type: 'UPDATE_EXPORT_RATES_RESPONSE', value: response });
    } catch (error) {
        yield put({ type: 'UPDATE_EXPORT_RATES_RESPONSE', value: error });
    }
}

export function* getRatesList() {
    yield takeEvery("GET_RATES_LIST", getList)
}

export function* getRateById() {
    yield takeEvery("GET_RATE", rateById)
}

export function* getRateByIdSearchCopies() {
    yield takeEvery("GET_RATE_SEARCH_COPIES", rateByIdSearchCopies)
}

export function* editRateById() {
    yield takeEvery("EDIT_RATE", editRate)
}

export function* getRateDetailJson() {
    yield takeEvery("GET_RATE_DETAIL_JSON", getRateDetail)
}

export function* uploadRateDetailFile() {
    yield takeEvery("UPLOAD_RATE_FILE", uploadRateFile)
}

export function* uploadRateDetailJson() {
    yield takeEvery("UPLOAD_RATE_JSON", uploadRateJson)
}

export function* getDuplicateRate() {
    yield takeEvery("GET_DUPLICATE_RATE", duplicateRate)
}

export function* getBatchUpdateRates() {
    yield takeEvery("GET_BACTH_UPDATE_RATES", getBatchAllRates)
}

export function* editBatchUpdateRates() {
    yield takeEvery("EDIT_BATCH_UPDATE_RATES", updateBatchRates)
}

export function* getRatesFiltered() {
    yield takeEvery("GET_RATES_FILTERED", getFilteredRates)
}

export function* editUpdateMarketRates() {
    yield takeEvery("EDIT_UPDATE_MARKET_RATES", updateMarketRates)
}
export function* deleteUpdateMarketRates() {
    yield takeEvery("DELETE_UPDATE_MARKET_RATES", deleteMarketRates)
}
export function* deleteRateRelationsSaga() {
    yield takeEvery("DELETE_RATE_RELATIONS", deleteRateRelations)
}
export function* createRateRelationsSaga() {
    yield takeEvery("CREATE_RATE_RELATIONS", createRateRelations)
}

export function* downloadRateValues() {
    yield takeEvery("DOWNLOAD_RATE_VALUE", downloadRate)
}

export function* checkExportRates() {
    yield takeEvery('CHECK_EXPORT_RATES', checkExportRate);
}

export function* getHashExportRatesList() {
    yield takeEvery('GET_HASH_EXPORT_RATES', hashExportListRates);
}

export function* checkExportRatesList() {
    yield takeEvery('CHECK_EXPORT_RATES', checkExportListRates);
}

export function* updateExportRatesList() {
    yield takeEvery('UPDATE_EXPORT_RATES', updateExportListRates);
}